import { render, staticRenderFns } from "./PageDescribe.vue?vue&type=template&id=05bfbd8a&scoped=true"
import script from "./PageDescribe.vue?vue&type=script&lang=ts"
export * from "./PageDescribe.vue?vue&type=script&lang=ts"
import style0 from "./PageDescribe.vue?vue&type=style&index=0&id=05bfbd8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bfbd8a",
  null
  
)

export default component.exports